module.exports = __webpack_public_path__ + "static/media/zone.43957239.png";